/* NestlingSpace theme — shared behaviour */
(function () {
  /* ---------- Scroll reveal ---------- */
  function initReveal(scope) {
    if (!document.body.classList.contains('ns-animate')) return;
    var els = (scope || document).querySelectorAll('.ns-reveal:not(.ns-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('ns-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('ns-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Results counters ---------- */
  function initResults(scope) {
    var rows = (scope || document).querySelectorAll('[data-ns-pct]:not([data-done])');
    var animate = function (el) {
      el.setAttribute('data-done', '');
      var pct = parseFloat(el.getAttribute('data-ns-pct')) || 0;
      var bar = el.querySelector('.ns-results__bar');
      var num = el.querySelector('.ns-results__num');
      if (bar) { var c = parseFloat(bar.getAttribute('data-c')); bar.style.strokeDashoffset = String(c - (c * pct) / 100); }
      if (num) {
        var start = null;
        var step = function (t) { if (!start) start = t; var p = Math.min((t - start) / 1400, 1); num.textContent = Math.round(pct * p) + '%'; if (p < 1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      }
    };
    if (!('IntersectionObserver' in window)) { rows.forEach(animate); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animate(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.3 });
    rows.forEach(function (r) { io.observe(r); });
  }

  /* ---------- Slider ---------- */
  if (!customElements.get('ns-slider')) {
    customElements.define('ns-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ns-slider__track');
        if (!this.track) return;
        this.prev = this.querySelector('.ns-slider__arrow--prev');
        this.next = this.querySelector('.ns-slider__arrow--next');
        this.dotsWrap = this.querySelector('.ns-slider__dots');
        this.loop = this.dataset.loop === 'true';
        this.slides = Array.from(this.track.children);
        if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
        if (this.next) this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', () => { window.requestAnimationFrame(() => this.update()); }, { passive: true });
        window.addEventListener('resize', () => this.build());
        this.build();
        var speed = parseInt(this.dataset.autoplay || '0', 10);
        if (speed > 0 && !(window.Shopify && Shopify.designMode)) {
          this.timer = setInterval(() => { if (!this.matches(':hover')) this.go(1, true); }, speed * 1000);
        }
      }
      disconnectedCallback() { clearInterval(this.timer); }
      perView() {
        var cs = getComputedStyle(this);
        var v = window.innerWidth >= 750 ? cs.getPropertyValue('--per-view-d') : cs.getPropertyValue('--per-view-m');
        return Math.max(1, parseInt(v, 10) || 1);
      }
      pages() { return Math.max(1, this.slides.length - this.perView() + 1); }
      build() {
        if (!this.dotsWrap) { this.update(); return; }
        var n = this.pages();
        if (this.dotsWrap.children.length !== n) {
          this.dotsWrap.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'ns-slider__dot'; b.setAttribute('aria-label', 'Slide ' + (i + 1));
            b.addEventListener('click', ((idx) => () => this.to(idx))(i));
            this.dotsWrap.appendChild(b);
          }
        }
        this.update();
      }
      index() {
        var w = this.slides[0] ? this.slides[0].getBoundingClientRect().width : 1;
        var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return Math.round(this.track.scrollLeft / (w + gap));
      }
      to(i) {
        var s = this.slides[i];
        if (!s) return;
        this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }
      go(dir, auto) {
        var i = this.index() + dir, max = this.pages() - 1;
        if (i > max) i = (this.loop || auto) ? 0 : max;
        if (i < 0) i = this.loop ? max : 0;
        this.to(i);
      }
      update() {
        var i = this.index(), max = this.pages() - 1;
        if (this.prev) this.prev.disabled = !this.loop && i <= 0;
        if (this.next) this.next.disabled = !this.loop && i >= max;
        if (this.dotsWrap) Array.from(this.dotsWrap.children).forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
        var hide = max <= 0;
        var nav = this.querySelector('.ns-slider__nav');
        if (nav) nav.style.visibility = hide ? 'hidden' : '';
      }
    });
  }

  /* ---------- Video slides ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ns-video-toggle]');
    if (!btn) return;
    var wrap = btn.closest('.ns-vslide');
    var v = wrap && wrap.querySelector('video');
    if (!v) return;
    if (v.muted || v.paused) { v.muted = false; v.play(); btn.setAttribute('aria-pressed', 'true'); btn.querySelector('.ns-icon').textContent = 'volume_up'; }
    else { v.muted = true; btn.setAttribute('aria-pressed', 'false'); btn.querySelector('.ns-icon').textContent = 'volume_off'; }
  });

  /* ---------- Native reviews ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ns-rv-toggle]');
    if (t) {
      var form = document.getElementById(t.getAttribute('aria-controls'));
      if (form) { form.hidden = !form.hidden; t.setAttribute('aria-expanded', String(!form.hidden)); if (!form.hidden) form.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    var m = e.target.closest('[data-ns-rv-more-btn]');
    if (m) {
      var wrap = m.closest('[data-ns-reviews]');
      var per = parseInt(wrap.getAttribute('data-per-page'), 10) || 6;
      var hidden = wrap.querySelectorAll('[data-ns-rv-more][hidden]');
      for (var i = 0; i < hidden.length && i < per; i++) hidden[i].hidden = false;
      if (wrap.querySelectorAll('[data-ns-rv-more][hidden]').length === 0) m.parentNode.remove();
    }
  });
  /* ---------- Review photo carousel + lightbox ---------- */
  function rvTiles(gal) { return Array.prototype.slice.call(gal.querySelectorAll('[data-ns-rv-photo]')); }
  function rvNav(gal) {
    var tr = gal.querySelector('[data-ns-rv-gtrack]'); if (!tr) return;
    var b = gal.querySelectorAll('[data-ns-rv-gscroll]');
    var max = tr.scrollWidth - tr.clientWidth - 2;
    if (b[0]) b[0].disabled = tr.scrollLeft <= 2;
    if (b[1]) b[1].disabled = tr.scrollLeft >= max;
    var nav = gal.querySelector('.ns-rv__gallery-nav'); if (nav) nav.style.visibility = max <= 0 ? 'hidden' : '';
  }
  function rvOpen(wrap, tiles, i) {
    var lb = wrap.querySelector('[data-ns-rv-lb]'); if (!lb || !tiles[i]) return;
    lb._tiles = tiles; lb._i = i;
    var t = tiles[i];
    var img = lb.querySelector('[data-ns-rv-lb-img]');
    img.src = t.getAttribute('data-src'); img.alt = t.getAttribute('aria-label') || '';
    var body = lb.querySelector('[data-ns-rv-lb-body]'); body.innerHTML = '';
    var tpl = document.getElementById(t.getAttribute('data-review'));
    if (tpl) body.appendChild(tpl.content.cloneNode(true));
    lb.querySelectorAll('[data-ns-rv-lb-step]').forEach(function (n) { n.style.display = tiles.length > 1 ? '' : 'none'; });
    if (lb.hidden) { lb.hidden = false; document.documentElement.classList.add('ns-lb-open'); lb._return = t; lb.querySelector('.ns-rv-lb__close').focus(); }
  }
  function rvClose(lb) { lb.hidden = true; document.documentElement.classList.remove('ns-lb-open'); if (lb._return) lb._return.focus(); }
  document.addEventListener('click', function (e) {
    var tile = e.target.closest('[data-ns-rv-photo]');
    if (tile) { var gal = tile.closest('[data-ns-rv-gallery]'); var tiles = rvTiles(gal); rvOpen(tile.closest('[data-ns-reviews]'), tiles, tiles.indexOf(tile)); return; }
    var sc = e.target.closest('[data-ns-rv-gscroll]');
    if (sc) { var tr = sc.closest('[data-ns-rv-gallery]').querySelector('[data-ns-rv-gtrack]'); tr.scrollBy({ left: parseInt(sc.getAttribute('data-ns-rv-gscroll'), 10) * tr.clientWidth * 0.8, behavior: 'smooth' }); return; }
    var st = e.target.closest('[data-ns-rv-lb-step]');
    if (st) { var lb = st.closest('[data-ns-rv-lb]'); var n = lb._tiles.length; rvOpen(st.closest('[data-ns-reviews]'), lb._tiles, (lb._i + parseInt(st.getAttribute('data-ns-rv-lb-step'), 10) + n) % n); return; }
    var cl = e.target.closest('[data-ns-rv-lb-close]');
    if (cl) rvClose(cl.closest('[data-ns-rv-lb]'));
  });
  document.addEventListener('keydown', function (e) {
    var lb = document.querySelector('[data-ns-rv-lb]:not([hidden])'); if (!lb) return;
    if (e.key === 'Escape') rvClose(lb);
    else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { var n = lb._tiles.length; rvOpen(lb.closest('[data-ns-reviews]'), lb._tiles, (lb._i + (e.key === 'ArrowRight' ? 1 : -1) + n) % n); }
  });
  function initRvGallery(scope) {
    (scope || document).querySelectorAll('[data-ns-rv-gallery]').forEach(function (g) {
      var tr = g.querySelector('[data-ns-rv-gtrack]'); if (!tr || tr._nsBound) return; tr._nsBound = true;
      tr.addEventListener('scroll', function () { requestAnimationFrame(function () { rvNav(g); }); }, { passive: true });
      window.addEventListener('resize', function () { rvNav(g); });
      rvNav(g);
    });
  }

  // Re-open the review form after a contact-form post so the thank-you message is visible
  if (location.search.indexOf('contact_posted=true') > -1 || location.hash.indexOf('ReviewForm') > -1) {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.ns-rv__form').forEach(function (f) { if (f.querySelector('.ns-rv__thanks')) f.hidden = false; });
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-ns-sticky-atc]');
    if (!bar) return;
    var target = document.querySelector('.product-form__buttons') || document.querySelector('.product__info-container');
    var mode = bar.getAttribute('data-display');
    if (mode === 'always' || !target || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
      });
    }).observe(target);
    var sel = bar.querySelector('select[name="id"]');
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      var p = bar.querySelector('[data-ns-sticky-price]');
      var c = bar.querySelector('[data-ns-sticky-compare]');
      if (p) p.textContent = o.getAttribute('data-price');
      if (c) c.textContent = o.getAttribute('data-compare') || '';
      var btn = bar.querySelector('button[type="submit"]');
      if (btn) btn.disabled = o.hasAttribute('data-unavailable');
    });
  }

  /* ---------- Shipping checkpoint dates ---------- */
  function initCheckpoints(scope) {
    (scope || document).querySelectorAll('[data-ns-checkpoints]').forEach(function (wrap) {
      var days = (wrap.getAttribute('data-days') || '').split(',').map(function (s) { return s.trim(); });
      var months = (wrap.getAttribute('data-months') || '').split(',').map(function (s) { return s.trim(); });
      var fmt = wrap.getAttribute('data-format') || 'mm_dd';
      var label = function (d) {
        var day = days[(d.getDay() + 6) % 7] || '';
        var m = months[d.getMonth()] || '';
        var dd = d.getDate();
        if (fmt === 'mmm_d') return m + ' ' + dd;
        if (fmt === 'd_mmm') return dd + ' ' + m;
        return fmt === 'dd_mm' ? day + ', ' + dd + ' ' + m : day + ', ' + m + ' ' + dd;
      };
      wrap.querySelectorAll('[data-min]').forEach(function (el) {
        var now = new Date();
        var a = new Date(now); a.setDate(now.getDate() + parseInt(el.getAttribute('data-min'), 10));
        var b = new Date(now); b.setDate(now.getDate() + parseInt(el.getAttribute('data-max'), 10));
        el.innerHTML = el.innerHTML.replace(/\[start_date\]/g, label(a)).replace(/\[end_date\]/g, label(b));
      });
    });
  }

  function initAll(scope) { initReveal(scope); initResults(scope); initCheckpoints(scope); initRvGallery(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); initSticky(); });
  else { initAll(); initSticky(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initSticky(); });
})();
